import { z } from 'zod';

import {
  zodTaxCodesOrderBySchema,
  zodTaxCodesSortOrderSchema,
} from '~/data/taxCode';

export const zodTaxCodesSearchSchema = z.object({
  limit: z.number().int().min(1).max(500).catch(50),
  orderBy: zodTaxCodesOrderBySchema
    .default('company_name')
    .catch('company_name'),
  page: z.number().int().min(0).catch(0),
  savedFilterId: z.uuid().optional().catch(undefined),
  sortOrder: zodTaxCodesSortOrderSchema.default('ASC').catch('ASC'),
  taxCodeId: z.uuid().optional().catch(undefined),
});

export const defaultTaxCodesSearch = zodTaxCodesSearchSchema.parse({});

export type TaxCodesSearch = z.infer<typeof zodTaxCodesSearchSchema>;
